import {ZIDXFormField} from "../form/FormField.js";
import {ZIDXFormFieldType} from "../form/FormFieldType.js";

export class ZIDXImageFormField extends ZIDXFormField{
    sizes="";
    uploadPath="";
    downloadPath="";
    constructor() {
        super();
        this.type=ZIDXFormFieldType.IMAGE;
    }
}